import { useEffect } from 'react';
import { FormikProps } from 'formik';

function useFocusFirstError<T>(formik: FormikProps<T>) {
	useEffect(() => {
		if (!formik.isSubmitting && !formik.isValidating) return;
		if (Object.keys(formik.errors).length > 0) {
			const firstErrorField = Object.keys(formik.errors)[0];
			focusFirstErrorField(firstErrorField);
		}
	}, [formik.isSubmitting, formik.errors]);

	const focusFirstErrorField = (fieldName: string) => {
		const errorElement = document.getElementsByName(fieldName)[0] as HTMLElement;
		errorElement?.scrollIntoView({ behavior: 'smooth', block: 'center' });
		errorElement?.focus({ preventScroll: true });
	};
}

export default useFocusFirstError;
